<template>
    <div>
        <h2 class="text-3xl font-hairline mb-2">Bids</h2>
        <well class="!p-0">
            <div>
                <div class="px-8 py-3">
                    <div class="flex">
                        <div class="w-7/12">
                            <span class="uppercase text-sm font-bold text-gray-600">Freelancer Bidding (2)</span>
                        </div>
                        <div class="hidden lg:block w-3/12">
                            <span class="uppercase text-sm font-bold text-gray-600">Reputation</span>
                        </div>
                        <div class="hidden lg:block w-2/12">
                            <span class="uppercase text-sm font-bold text-gray-600">Bid</span>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="border-b border-gray-200">
                    <div class="px-8 py-6 text-lg">
                        <div class="flex flex-col lg:flex-row">
                            <div class="w-full mb-5 lg:mb-0 lg:w-7/12 mx-2">
                                <div class="flex flex-col lg:flex-row items-start w-full">
                                    <user-avatar class="w-16 h-16 mb-2 lg:mb-0" username="Ahmad Khan"></user-avatar>
                                    <div class="flex-1">
                                        <div class="flex flex-col lg:px-4">
                                            <span class="font-bold text-2xl">Mustafa Ehsan</span>
                                            <span class="text-teal-500">Software Developer</span>
                                            <span class="text-gray-600">Afghanistan</span>
                                            <div class="mt-2 text-gray-500 text-base">
                                                A lot of description about this topic is here, we cannot see it, but we try. A lot
                                                of description about this topic is here, we cannot see it, but we try. A lot of
                                                description about this topic is here, we cannot see it, but we try.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="w-full mb-5 lg:mb-0 lg:w-3/12 mx-2 text-base">
                                <div class="text-gray-700">
                                    <user-rating class="mb-2" :rating="2" :read-only="true"></user-rating>
                                    <div>20 year(s) experience</div>
                                    <div>1 job(s) worked</div>
                                </div>
                            </div>
                            <div class="w-full mb-5 lg:mb-0 lg:w-2/12 mx-2 text-base">
                                <div class="flex flex-col text-gray-800">
                                    <span class="text-2xl font-bold">$300</span>
                                    <span class="text-gray-700">in 10 days</span>
                                </div>
                            </div>
                        </div>
                        <div class="actions mt-2 lg:mt-4">
                            <div class="lg:flex">
                                <div class="w-16"></div>
                                <div class="flex-1">
                                    <div class="lg:px-6">
                                        <button class="btn btn-primary px-8 font-bold uppercase text-sm">Accept Bid</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </well>
    </div>
</template>

<script>
export default {};
</script>
